//authServices.js
import apiClient from '../api/apiClient';

const authServices = {

  login: async (mobile, password) => {
    try {
      const response = await apiClient.post(`/login/panelLogin`, {
        mobile: mobile,
        password: password,
      });

      if (response.data.Status === 'SUCCESS') {
        // Store all user information in localStorage
        const data = response.data.data;
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data));
        localStorage.setItem('UserRole', data.userType);
        localStorage.setItem('UserMobile', data.mobile);
        localStorage.setItem('UserName', data.name);

        return {
          success: {
            user: {
              role: data.userType,
              name: data.name,
              mobile: data.mobile,
            },
            token: data.token
          }
        };
      } else {
        return { errorMsg: response.data.message || "Login failed" };
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An unknown error occurred";
      console.error("Login error: ", errorMessage);
      return { errorMsg: errorMessage };
    }
  },

  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('UserRole');
    localStorage.removeItem('UserName');
    localStorage.removeItem('UserMobile');
    localStorage.removeItem('dark-mode');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');  // Returns true if token exists
  },

  getToken: () => {
    return localStorage.getItem('authToken');
  },

  refreshToken: async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const response = await apiClient.post('/api/auth/refresh-token/', {
        refresh_token: refreshToken
      });

      if (response.data.success) {
        // Update tokens in localStorage
        localStorage.setItem('authToken', response.data.data.access);
        localStorage.setItem('refreshToken', response.data.data.refresh);
        
        // Update user data if provided
        if (response.data.data.user) {
          localStorage.setItem('UserRole', response.data.data.user.role);
          localStorage.setItem('UserMobile', response.data.data.user.mobile);
          localStorage.setItem('UserId', response.data.data.user.id);
          localStorage.setItem('user', JSON.stringify(response.data.data.user));
        }
        
        return { success: true, access: response.data.data.access };
      } else {
        throw new Error(response.data.message || 'Token refresh failed');
      }
    } catch (error) {
      console.error('Token refresh error:', error);
      return { success: false, error: error.message };
    }
  },

  changePassword: async (oldPassword, newPassword, confirmPassword) => {
    try {
      const response = await apiClient.post('/api/auth/change-password/', {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword
      });

      return response.data;
    } catch (error) {
      console.error('Change password error:', error);
      
      if (error.response?.data) {
        return error.response.data;
      }
      
      return { 
        success: false, 
        message: 'Failed to change password. Please try again.' 
      };
    }
  },
};

export default authServices;